import React, { Component } from 'react'

export default class SessionPage extends Component {
  render() {
    return <main className="page">Průběh sezení</main>
  }
}
